import React, { Component, createRef } from 'react';
import * as Constants from '../../common/Global/constants';
import {compareObjects, getLocalStorageVariables, handleTokenExpiry, isEmptyArray, isEmptyVariable } from '../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import {DialogSaveButton} from '../../common/Global/globalStyles.style';
import AlertDialog from '../../common/AlertDialog';
import { DatePicker } from 'antd';
import moment from 'moment';
import RegularDropDown from '../../common/DropdownMenus/RegularDropdown';

let userDetails = getLocalStorageVariables();
const versionTypeDefaultPlaceholder = "Select Version Type";
const previousVersionDefaultPlaceholder = "Select Previous Version Name";

class AddRootFrameworkDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag: false,
            showLoader: false,
            frameworkId:"",
            frameworkName: "",
            frameworkShortName: "",
            versionType:"",
            versionTypePlaceholder:"",
            versionTypeArr:Constants.VERSION_TYPE,
            previousVersionArr:[],
            previousVersionPlaceholder:"",
            frameworkVersion:"",
            previousVersion:"",
            validFromDate:"",
            validToDate:"",
            formErrors: {},
            submitClickedAtleastOnce: false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            initialValue:{}
        }
        this.frameworkNameRef = createRef();
        userDetails = getLocalStorageVariables();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showCreateDialog){
            if(this.props.isEdit){
                let dropdownItem = this.props.selectedItem;
                let previousVersionPlaceholder = this.props.previousVersionArr.filter(item => item.frameworkId === dropdownItem.previousVersion);
                
                const initialValue = {
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    frameworkName:dropdownItem.frameworkName,
                    frameworkShortName:isEmptyVariable(dropdownItem.frameworkShortName)?"":dropdownItem.frameworkShortName,
                    versionType:isEmptyVariable(dropdownItem.versionType)?"":dropdownItem.versionType,
                    frameworkVersion:isEmptyVariable(dropdownItem.frameworkVersion)?"":dropdownItem.frameworkVersion,
                    previousVersion:isEmptyVariable(dropdownItem.previousVersion)?"":dropdownItem.previousVersion,
                    validFromDate:isEmptyVariable(dropdownItem.validFromDate)?"":moment(dropdownItem.validFromDate).format("YYYY-MM-DD"),
                    validToDate:isEmptyVariable(dropdownItem.validToDate)?"":moment(dropdownItem.validToDate).format("YYYY-MM-DD"),
                    frameworkId:dropdownItem.frameworkId
                }
                
                this.setState({
                    componentDidMountFlag: false,
                    showLoader: false,
                    frameworkId: dropdownItem.frameworkId,
                    frameworkName: dropdownItem.frameworkName,
                    previousVersionArr: this.props.previousVersionArr,
                    frameworkShortName: isEmptyVariable(dropdownItem.frameworkShortName)?"":dropdownItem.frameworkShortName,
                    versionType: isEmptyVariable(dropdownItem.versionType)?"":dropdownItem.versionType,
                    versionTypePlaceholder: isEmptyVariable(dropdownItem.versionType)?versionTypeDefaultPlaceholder:dropdownItem.versionType.charAt(0).toUpperCase() + dropdownItem.versionType.slice(1),
                    frameworkVersion: isEmptyVariable(dropdownItem.frameworkVersion)?"":dropdownItem.frameworkVersion,
                    previousVersion: isEmptyVariable(dropdownItem.previousVersion)?"":dropdownItem.previousVersion,
                    previousVersionPlaceholder:isEmptyArray(previousVersionPlaceholder)?"":previousVersionPlaceholder[0].previousVersion,
                    validFromDate: isEmptyVariable(dropdownItem.validFromDate)?"":moment(dropdownItem.validFromDate).format("YYYY-MM-DD"),
                    validToDate: isEmptyVariable(dropdownItem.validToDate)?"":moment(dropdownItem.validToDate).format("YYYY-MM-DD"),
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                    initialValue:initialValue
                })
            }else{
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
                    frameworkId:"",
                    frameworkName:"",
                    frameworkShortName: "",
                    versionTypePlaceholder:"",
                    frameworkVersion:"",
                    previousVersion:"",
                    validFromDate:"",
                    validToDate:"",
                    formErrors:{},
                    previousVersionPlaceholder:"",
                    previousVersionArr: this.props.previousVersionArr,
                    submitClickedAtleastOnce:false,
                    initialValue:{}
                })
            }
            setTimeout(() => {
                if (this.frameworkNameRef.current) {
                    this.frameworkNameRef.current.focus();
                }
            });
        }
    }

    // Updates state with input field changes.
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    // Updates valid from date state and clears valid to date if it's before the new from date.
    onvalidFromDateChange = (date, dateString) => {
        let validFromDate = "";
		if (!isEmptyVariable(date)) {
			validFromDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['validFromDate'] = "";

        let validToDate = this.state.validToDate;
        if (validToDate && moment(validFromDate).isAfter(moment(validToDate))) {
            validToDate = "";
            FormErrorsTemp['validToDate'] = "";
        }

		this.setState({
            validFromDate:validFromDate,
            validToDate:validToDate,
            formErrors:FormErrorsTemp
        })
    }

    // Updates valid to date state.
    onValidToDateChange = (date, dateString) => {
		let validToDate = "";
		if (!isEmptyVariable(date)) {
			validToDate = date.format("YYYY-MM-DD");
        }
        let FormErrorsTemp = this.state.formErrors;
        FormErrorsTemp['validToDate'] = "";

		this.setState({
            validToDate:validToDate,
            formErrors:FormErrorsTemp
        })
    };

    // Checks if a date is in the future.
    disableFutureDates = (current) => {
        return current && current > moment().endOf('day');
    };

    // Checks if a date is before the valid from date or in the future.
    disabledToDate = (current) => {
        const { validFromDate } = this.state;
        if (this.disableFutureDates(current)) {
            return true;
          }
          return validFromDate ? current && current < moment(validFromDate, "YYYY-MM-DD") : false;
    };

    // Handles the click event on the version type dropdown.
    versionTypeDropdownClick = (item) => {
        let FormErrorsTemp  = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['versionType'] = "";
        }

        if(item.versionType === "clause"){
            this.setState({
                validFromDate:"",
                validToDate:""
            })
        }
        this.setState({
            versionTypePlaceholder: item.displayLabel,
            versionType: item.versionType,
            formErrors:FormErrorsTemp,
        })
    }

    // Updates the state with the selected previous version.
    previousVersionDropdownClick = (item) => {
        this.setState({
            previousVersion: item.frameworkId,
            previousVersionPlaceholder: item.previousVersion,
        })
    }

    // Closes the create dialog.
    handleCreateDialogClose = () =>{
        this.props.handleAddEditDialogClose(false);
    }

    // Handles the enter key press event to create a master.
    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.handleCreateMaster();
        }
    }

    // Closes the alert dialog and clears its message.
    handleAlertDialogCloseInfo = () =>{
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    /************************API CALLS **************************/
    handleCreateMaster = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};

        if(isEmptyVariable(this.state.frameworkName)){
            isError = true;
            FormErrorsTemp['frameworkName'] = "Please enter framework name";
        }

        if(isEmptyVariable(this.state.versionType)){
            isError = true;
            FormErrorsTemp['versionType'] = "Please select version type";
        }

        if(this.state.versionType === "framework" && isEmptyVariable(this.state.validFromDate)){
            isError = true;
            FormErrorsTemp['validFromDate'] = "Please select valid from date";
        }

        if(isError){
            this.setState({
                formErrors: FormErrorsTemp,
                showLoader: false,
            });

        }else{
            let url = "";
            let postParam = {
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                frameworkName:this.state.frameworkName,
                frameworkShortName:this.state.frameworkShortName,
                versionType:this.state.versionType,
                frameworkVersion:this.state.frameworkVersion,
                previousVersion:this.state.previousVersion,
                validFromDate:this.state.validFromDate,
                validToDate:this.state.validToDate
            }

            if(this.props.isEdit){
                url = Constants.UpdateRootFramework;
                postParam.frameworkId = this.state.frameworkId;
            }else{
                url = Constants.CreateRootFramework;
            }
            
            const hasChanges = !compareObjects(this.state.initialValue, postParam);
            if(!hasChanges && !isEmptyArray(Object.keys(this.state.initialValue))){
                this.props.handleAddEditDialogClose()
            }else{
                fetch(url,
                {
                    method: "POST",
                    mode:'cors',
                    body: new URLSearchParams(postParam)
                })
                .then(response => { return response.json(); } )
                .then(data =>
                {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                            this.setState({
                                showLoader:false,
                                formErrors:{},
                            },() => {
                                this.props.handleAddEditDialogClose(true);
                            });
                    }else{
                        this.setState({
                            showAlertDialogInfo:true,
                            alertDialogMessageInfo:data.responseMessage,
                            showLoader:false
                        });
                    }
                });
            }
        }
    }
    /************************API CALLS END HERE**************************/

    render() {
        return(
            <>
            <Modal className="custom-dialog" show={this.props.showCreateDialog} onHide={this.handleCreateDialogClose} backdrop="static">
                <Modal.Header>
                    <h5>{this.props.isEdit?"Edit Framework":"Add Framework"}</h5>
                    <button 
                        onClick={this.handleCreateDialogClose}
                        type="button" data-dismiss="modal">
                        <span className="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div className="modal-body">
                    <div className="addnew-modal-form">
                        <div className="addnew-modal-form-group">
                            <p>Framework Name*</p>
                            <input type="text" placeholder="Enter Framework Name" spellCheck="true" 
                            name="frameworkName" value={this.state.frameworkName} onChange={this.handleChange} ref={this.frameworkNameRef} />
                            {
                                !isEmptyVariable(this.state.formErrors['frameworkName']) &&
                                <span className="cm-error">{this.state.formErrors['frameworkName']}</span>
                            }
                        </div>
                        <div className="addnew-modal-form-group">
                            <p>Framework Short Name</p>
                            <input type="text" placeholder="Enter Framework Short Name" spellCheck="true" 
                            name="frameworkShortName" value={this.state.frameworkShortName} onChange={this.handleChange} />
                        </div>
                        <div className="addnew-modal-form-group">
                            <p>Version Type*</p>
                            <RegularDropDown
                                placeholder={isEmptyVariable(this.state.versionTypePlaceholder)?versionTypeDefaultPlaceholder:this.state.versionTypePlaceholder}
                                dropdownArr={this.state.versionTypeArr}
                                labelParam="displayLabel"
                                onDropDownItemClick={this.versionTypeDropdownClick}
                                defaultPlaceholderDropDown={versionTypeDefaultPlaceholder}
                            />
                            {
                                !isEmptyVariable(this.state.formErrors['versionType']) &&
                                <span className="cm-error">{this.state.formErrors['versionType']}</span>
                            }
                        </div>
                        <div className="addnew-modal-form-group">
                            <p>Framework Version</p>
                            <input type="text" placeholder="Enter Framework Version" spellCheck="true" 
                            name="frameworkVersion" value={this.state.frameworkVersion} onChange={this.handleChange} />
                        </div>
                        <div className="addnew-modal-form-group">
                            <p>Previous Version</p>
                            <RegularDropDown
                                placeholder={isEmptyVariable(this.state.previousVersionPlaceholder)?previousVersionDefaultPlaceholder:this.state.previousVersionPlaceholder}
                                dropdownArr={this.state.previousVersionArr}
                                labelParam="previousVersion"
                                onDropDownItemClick={this.previousVersionDropdownClick}
                                defaultPlaceholderDropDown={previousVersionDefaultPlaceholder}
                            />
                        </div>
                        {this.state.versionType === "framework" &&
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Valid From Date*</p>
                                        <DatePicker
                                            onChange={this.onvalidFromDateChange}
                                            format={"DD/MM/YYYY"}
                                            disabledDate={this.disableFutureDates}
                                            value={!isEmptyVariable(this.state.validFromDate) ? moment(this.state.validFromDate) : ""}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['validFromDate']) &&
                                            <span className="cm-error">{this.state.formErrors['validFromDate']}</span>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Valid To Date</p>
                                        <DatePicker
                                            onChange={this.onValidToDateChange}
                                            format={"DD/MM/YYYY"}
                                            disabledDate={this.disabledToDate}
                                            value={!isEmptyVariable(this.state.validToDate) ? moment(this.state.validToDate) : ""}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="modal-close-save">
                            <div className="close-save-col">
                                <button onClick={this.handleCreateDialogClose} type="button" className="modal-close">Cancel</button>
                                <DialogSaveButton 
                                themeSettings={this.props.themeSettings}
                                onClick={this.handleCreateMaster} type="button" className="modal-save">
                                    {this.state.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                                </DialogSaveButton>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <AlertDialog
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type={Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL }
                themeSettings={this.props.themeSettings}
            />
        </>
        );
    }
}

export default AddRootFrameworkDialog;